// r24 — /translate/naati/faq/$slug (TH)
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiFaqRenderer from "@/components/NaatiFaqRenderer";
import type { NAATI_FAQS as NaatiFaqList } from "@/data/naati-faq-bank";

type NaatiFaq = (typeof NaatiFaqList)[number];
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";

export const Route = createFileRoute("/translate/naati/faq/$slug")({
  loader: async ({ params }) => {
    const { NAATI_FAQS } = await import("@/data/naati-faq-bank");
    const f = NAATI_FAQS.find((x) => x.slug === params.slug);
    if (!f) throw notFound();
    return { faq: f as NaatiFaq };
  },
  head: ({ loaderData }) => {
    const f = loaderData?.faq;
    if (!f) return { meta: [{ title: ctaTitle("Not found", "/translate/naati/faq/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const url = `${SITE}/translate/naati/faq/${f.slug}`;
    const title = `${f.questionTh} | NAATI FAQ — NYC Language Institute`;
    return {
      meta: [
        { title: ctaTitle(title, "/translate/naati/faq/$slug", "th") }, { name: "description", content: ctaDesc(f.shortAnswerTh, "/translate/naati/faq/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/translate/naati/faq/$slug", "th")},
        { property: "og:description", content: ctaDesc(f.shortAnswerTh, "/translate/naati/faq/$slug", "th")},
        { property: "og:url", content: url }, { property: "og:locale", content: "th_TH" },
      ],
      links: canonicalAndHreflang(`/translate/naati/faq/${f.slug}`, `/en/translate/naati/faq/${f.slug}`),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "th",
          mainEntity: [{ "@type": "Question", name: f.questionTh, acceptedAnswer: { "@type": "Answer", text: f.longAnswerTh } }],
        }) },
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "WebPage", "@id": `${url}#speakable`, url,
          speakable: { "@type": "SpeakableSpecification", cssSelector: ["[data-speakable]", ".direct-answer", "h1"] },
        }) },
      ],
    };
  },
  component: () => {
    const { faq } = Route.useLoaderData();
    return <NaatiFaqRenderer locale="th" faq={faq} />;
  },
});
